export default __webpack_public_path__ + "images/DL.c47391c.png";